import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthenticationService } from '../authentication/authentication.service';
import { CredentialsService } from '../authentication/credentials.service';
import { LoginContext } from 'src/services/login-context.model';

@Injectable({
  providedIn: 'root'
})
export class ErrorInterceptorService implements HttpInterceptor {

  profile: LoginContext | null;
  constructor(private authService: AuthenticationService,
    private credentialService: CredentialsService, private router: Router) {
    this.profile = this.credentialService.credentials;
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(catchError(err => {
      if (err.status === 401) {
        this.authService.logout('LOGGED_OUT')
        this.router.navigate(['/login']);
        //   location.reload(true);
      }
      //   console.log("error details: ", err)
      const error = err.message || err.statusText;
      return throwError(error);
    }));
  }

}
